<template>
  <div>
    <headline
      :content="$t('payment.bank_account')"
    >
      <div class="d-block w-100">
        <div class="d-flex justify-end mb-2">
          <v-btn elevation="1" right color="info" @click="addBank()">
            <v-icon left>mdi-plus-box-multiple</v-icon>
            {{ $t('payment.add_bank_account') }}
          </v-btn>
        </div>
      </div>
    </headline>
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <div v-if="!isLoading">
          <v-card v-for="bankAccount in bankAccounts" :key="bankAccount.objectId" class="my-3">
            <v-list-item three-line>
              <v-list-item-avatar
                tile
                size="145"
              >
                <v-img :src="require(`@/assets/images/bank/${bankAccount.bankCode}.jpg`)" />
              </v-list-item-avatar>
              <v-list-item-content>
                <h2><b>{{ bankData[bankAccount.bankCode].name }}</b></h2>
                <p><b>{{ $t('payment.branch') }} : </b> {{ bankAccount.accountBranch }}</p>
                <p><b>{{ $t('payment.account_name') }} : </b> {{ bankAccount.accountName }}</p> 
                <p><b>{{ $t('payment.account_number') }} : </b> {{ bankAccount.accountNumber }}</p>
                <p><b>{{ $t('accounting_product.code') }} : </b> {{ bankAccount.erpCode || "-" }}</p>
                <p><b>{{ $t('market.market_seen_by_trader') }} : </b> 
                  <template v-if="bankAccount.isShowCustomer">
                    <span v-if="bankAccount.selectedMarkets">{{ bankAccount.selectedMarkets.map(d => d.name).join(",") }}</span>
                    <span v-else>{{ markets.map(d => d.name).join(",") }}</span>
                  </template>
                  <span class="red--text" v-else>
                    {{ $t('market.not_show_to_trader') }}
                  </span>
                </p>
              </v-list-item-content>
              <v-list-item-avatar
                tile
                size="120"
                class="text-end"
              >
                <v-card elevation="0">
                  <v-btn 
                    @click="editBankAccount(bankAccount)" 
                    class="my-1"
                    color="warning"
                    outlined
                  >
                    <v-icon class="mr-1">
                      mdi-pencil
                    </v-icon>
                    {{ $t('action_type.edit') }}
                  </v-btn>
                  <v-btn 
                    @click="removeBankAccount(bankAccount)" 
                    class="my-1"
                    color="error"
                    outlined
                  >
                    <v-icon class="mr-1">
                      mdi-trash-can-outline
                    </v-icon>
                    {{ $t('action_type.delete') }}
                  </v-btn>
                </v-card>
              </v-list-item-avatar>
            </v-list-item>
          </v-card>
        </div>
        <v-card class="d-flex justify-center py-10" elevation="0" v-else>
          <v-progress-circular
            indeterminate
            size="64"
            color="green"
          ></v-progress-circular>
        </v-card>
      </template>
    </layout>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <v-snackbar v-model="isSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
    </v-snackbar>
    <v-snackbar v-model="isRemoveSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('delete_success') }}
    </v-snackbar>
    <BankAccountManageDialog
      v-model="isBankAccountDialog"
      :projectId="projectId"
      :bankAccount="bankAccount"
      @onSaveSuccess="onSaveSuccess"
      @onError="isError = true"
    />
    <ConfirmDialog
      v-if="tempRemoveBankAccount"
      v-model="isConfirmRemoveDialog"
      :text="`${bankData[tempRemoveBankAccount.bankCode].name}  ${$t('payment.account_number')} : ${tempRemoveBankAccount.accountNumber}`"
      type="error"
      @onOk="onOkConfirmRemoveDialog"
      @onCancel="isConfirmRemoveDialog = false"
    />
  </div>
</template>

<script>
import BankAccountManageDialog from "@/components/BankAccountManageDialog.component"
import ConfirmDialog from "@/components/ConfirmDialog.component.vue"
import BankData from "../../json/bank-data.json"
import { mapState } from "vuex"
import Layout from "../../components/Layout"
import Headline from "../../components/Headline"
export default {
  data(){
    return {
      projectId: this.$route.params.projectId,
      isBankAccountDialog: false,
      isLoading: false,
      bankData: BankData,
      bankAccount: null,
      isError: false,
      isSuccess: false,
      isRemoveSuccess: false,
      isConfirmRemoveDialog: false,
      tempRemoveBankAccount: null,
      markets: null,
    }
  },
  components: {
    BankAccountManageDialog,
    ConfirmDialog,
    Layout,
    Headline
  },
  computed: {
    ...mapState({
      bankAccounts: state => state.bankAccount.bankAccounts,
      sessionAdmins: state => state.admin.sessionAdmins
    })
  },
  async created(){
    await this.initData()
  },
  methods: {
    async initData(){
      this.isLoading = true
      try{
        await this.$store.dispatch("bankAccount/getBankAccounts", this.projectId)
        this.markets = [];
        for (let admin of this.sessionAdmins) {
          if (this.projectId === admin.project.objectId) {
            this.markets.push(admin.market);
          }
        }
        this.isLoading = false
      }catch(error){
        this.isLoading = false
        this.isError = true
      }
    },
    addBank(){
      this.bankAccount = null
      this.isBankAccountDialog = true
    },
    editBankAccount(bankAccount){
      this.bankAccount = bankAccount
      this.isBankAccountDialog = true
    },
    async removeBankAccount(bankAccount){
      this.tempRemoveBankAccount = bankAccount
      this.isConfirmRemoveDialog = true
    },
    async onOkConfirmRemoveDialog(){
      try{
        await this.$store.dispatch("bankAccount/removeBankAccount", this.tempRemoveBankAccount.objectId)
        this.isRemoveSuccess = true
        this.isLoading = false
      }catch(error){
        this.isLoading = false
        this.isError = true
      }
    },
    async onSaveSuccess(){
      this.isSuccess = true
      await this.initData()
    }
  },
}
</script>

<style>

</style>